import { defineComponent as N, mergeModels as M, useModel as O, ref as p, watch as $, useAttrs as j, openBlock as s, createElementBlock as d, normalizeClass as m, unref as o, renderSlot as v, createElementVNode as h, withModifiers as g, withKeys as D, createBlock as G, createCommentVNode as w, Fragment as C, renderList as B } from "vue";
import J from "./BaseFloatingLabel.js";
import { useFloatingLabel as Q } from "./useFloatingLabel.js";
import { _ as R } from "./chunks/_plugin-vue_export-helper.CHgC5LLL.js";
import './assets/BaseInput.css';const W = ["id", "data-cy", "name", "autocomplete", "disabled", "aria-labelledby", "readonly", "type", "pattern", "min", "max", "maxlength", "inputmode", "placeholder", "value"], X = { class: "uikit-invisible uikit-float-none uikit-mb-2 uikit-ml-2 uikit-block uikit-h-3 uikit-w-auto uikit-max-w-full uikit-overflow-hidden uikit-whitespace-nowrap uikit-p-0 uikit-text uikit-transition-[max-width] uikit-duration-[50ms] uikit-ease-out" }, Y = ["innerHTML"], Z = ["innerHTML"], U = ["innerHTML"], x = {
  key: 1,
  class: "under-label uikit-absolute uikit-text-12"
}, _ = /* @__PURE__ */ N({
  inheritAttrs: !1,
  __name: "BaseInput",
  props: /* @__PURE__ */ M({
    inputClass: { default: "" },
    labelText: { default: "" },
    feedback: {},
    isValid: { default: null },
    keepFloatingLabel: { type: Boolean, default: !1 },
    formatter: { default: null }
  }, {
    modelValue: { default: "" },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ M(["click", "keydownEnterPressed", "focusin", "focusout", "keydown"], ["update:modelValue"]),
  setup(y, { expose: E, emit: H }) {
    const t = y, r = O(y, "modelValue"), l = p(""), f = H, {
      labelState: u,
      handleFocusIn: P,
      handleFocusOut: V,
      setInlineLabel: F,
      setFloatingLabel: L
    } = Q(f), n = p("text"), k = p({}), b = p(null), q = () => {
      t.feedback && (k.value = t.feedback, t.feedback.valid && typeof t.feedback.valid == "string" && (k.value.valid = [t.feedback.valid]), t.feedback.invalid && typeof t.feedback.invalid == "string" && (k.value.invalid = [t.feedback.invalid]));
    }, T = (e, i) => {
      if (!t.formatter || !t.formatter.formatFn)
        return l.value = e, "";
      const a = e.length ? t.formatter.formatFn(e) : e;
      return i && (i.value = a), l.value = a, a;
    }, I = (e, i = !0) => {
      if (i && (!t.formatter || !t.formatter.unFormatFn))
        return r.value = e, "";
      if (!i || !t.formatter || !t.formatter.unFormatFn)
        return;
      const a = t.formatter.unFormatFn(e);
      return r.value = a ?? "", a;
    }, z = ({ target: e }) => {
      const i = e, a = I(i.value);
      T(
        `${a}`,
        a === r.value ? i : void 0
      );
    }, S = () => {
      r.value = "", F();
    }, A = () => {
      n.value === "password" ? n.value = "text" : n.value === "text" && (n.value = "password");
    };
    $(
      () => t.feedback,
      () => {
        q();
      },
      {
        immediate: !0
      }
    ), $(
      r,
      (e) => {
        T(
          `${e}`,
          I(`${e}`, !1) === e ? b.value : void 0
        ), l.value != null && l.value.length > 0 && u.value !== "floating-label" ? L() : !l.value && document && document.activeElement !== b.value && F();
      },
      {
        immediate: !0
      }
    ), $(
      () => t.keepFloatingLabel,
      (e) => {
        e ? L() : V(r.value);
      }
    );
    const K = j();
    return n.value = K.type || "text", E({
      select: () => {
        b.value?.select();
      }
    }), (e, i) => (s(), d("div", {
      class: m(["input-wrapper uikit-relative uikit-inline-block uikit-w-full [&.has-right-icon.is-invalid_.text-input-icon]:uikit-mr-25px [&.has-right-icon.is-valid_.text-input-icon]:uikit-mr-25px", [
        e.$attrs.class,
        { "uikit-h-12": e.labelText },
        { "floating-label": e.labelText },
        o(u) === "floating-label" ? "floating-state" : "inline-state",
        {
          "has-right-icon": e.$attrs["with-right-icon"] !== void 0 ? e.$attrs["with-right-icon"] : !!e.$slots.righticon
        },
        {
          "has-left-icon": e.$attrs["with-left-icon"] !== void 0 ? e.$attrs["with-left-icon"] : !!e.$slots.leftIcon
        },
        { "is-invalid": e.isValid === !1, "is-valid": e.isValid }
      ]])
    }, [
      v(e.$slots, "leftIcon", {}, void 0, !0),
      v(e.$slots, "righticon", {
        handleClean: S,
        handleShowPasswd: A,
        curType: n.value
      }, void 0, !0),
      h("input", {
        id: e.$attrs.id,
        ref_key: "baseInputEl",
        ref: b,
        "data-cy": e.$attrs["data-cy"],
        name: e.$attrs.name,
        class: m(["input-element uikit-peer uikit-relative uikit-z-10 uikit-box-border uikit-block uikit-h-12 uikit-w-full uikit-appearance-none uikit-truncate uikit-rounded-xs !uikit-border-none uikit-bg-transparent uikit-bg-no-repeat uikit-px-4 uikit-pt-5px uikit-outline-0 focus:uikit-shadow-none focus:uikit-outline-none", [
          { "uikit-text-w-secondary": e.$attrs.disabled },
          {
            "is-invalid invalid-bg !uikit-pr-9": e.isValid === !1,
            "is-valid valid-bg !uikit-pr-9": e.isValid
          },
          {
            "uikit-pr-[42px]": e.$attrs["with-right-icon"] !== void 0 ? e.$attrs["with-right-icon"] : !!e.$slots.righticon
          },
          {
            "uikit-pl-[42px]": e.$attrs["with-left-icon"] !== void 0 ? e.$attrs["with-left-icon"] : !!e.$slots.leftIcon
          },
          e.inputClass
        ]]),
        autocomplete: e.$attrs.autocomplete === "on" ? "on" : "off",
        disabled: e.$attrs.disabled,
        "aria-labelledby": e.$attrs.id,
        readonly: e.$attrs.readonly,
        type: n.value,
        pattern: e.$attrs.pattern,
        min: e.$attrs.min,
        max: e.$attrs.max,
        maxlength: e.$attrs.maxlength,
        inputmode: e.$attrs.inputmode,
        placeholder: e.$attrs.placeholder,
        onClick: i[0] || (i[0] = (a) => f("click", a)),
        onFocusin: i[1] || (i[1] = g(() => e.labelText && o(P)(), ["stop"])),
        onFocusout: i[2] || (i[2] = g((a) => e.labelText && !e.keepFloatingLabel && o(V)(l.value), ["stop"])),
        onInput: g(z, ["stop"]),
        value: l.value,
        onKeydown: [
          i[3] || (i[3] = D(() => f("keydownEnterPressed"), ["enter"])),
          i[4] || (i[4] = (a) => f("keydown", a))
        ]
      }, null, 42, W),
      h("fieldset", {
        class: m(["uikit-pointer-events-none uikit-absolute uikit-bottom-0 uikit-left-0 uikit-right-0 uikit-m-0 uikit-box-border uikit-h-12 uikit-overflow-hidden uikit-rounded-xs uikit-border uikit-border-solid uikit-bg-white uikit-px-2 uikit-py-0 uikit-text-left uikit-transition-[border] uikit-duration-100 uikit-ease-out peer-focus:uikit-border-2 peer-focus:uikit-border-w-primary peer-focus:[&.is-invalid]:uikit-border-w-danger", [
          { "uikit-bg-w-cultured": e.$attrs.disabled },
          {
            "is-invalid uikit-border-w-danger": e.isValid === !1,
            "is-valid uikit-border-w-primary": e.isValid,
            "uikit-border-w-secondary": e.isValid === null
          },
          { "uikit-top-0": !e.labelText },
          e.$attrs["fieldset-classes"]
        ]])
      }, [
        h("legend", X, [
          h("span", {
            class: m(["visible-label uikit-opacity-0", [
              { "uikit-mx-5px": e.labelText },
              {
                "uikit-visible uikit-inline-block": o(u) === "floating-label"
              },
              {
                "uikit-invisible uikit-hidden": o(u) === "inline-label"
              }
            ]]),
            innerHTML: e.labelText
          }, null, 10, Y)
        ])
      ], 2),
      e.labelText ? (s(), G(J, {
        key: 0,
        for: e.$attrs.id,
        "label-text": e.labelText,
        "label-state": o(u),
        "is-valid": e.isValid,
        required: e.$attrs.required,
        disabled: e.$attrs.disabled,
        "label-classes": [
          o(u) === "floating-label" ? "!-uikit-top-1" : "!uikit-top-4",
          e.$attrs["label-classes"]
        ]
      }, null, 8, ["for", "label-text", "label-state", "is-valid", "required", "disabled", "label-classes"])) : w("", !0),
      v(e.$slots, "feedback", {}, () => [
        e.isValid === !1 ? (s(!0), d(C, { key: 0 }, B(k.value.invalid, (a, c) => (s(), d("div", {
          key: `${e.$attrs.id}_invalid_${c}`,
          class: "uikit-mt-1 uikit-text-12 uikit-text-w-danger",
          innerHTML: a
        }, null, 8, Z))), 128)) : e.isValid === !0 ? (s(!0), d(C, { key: 1 }, B(k.value.valid, (a, c) => (s(), d("div", {
          key: `${e.$attrs.id}_valid_${c}`,
          class: "uikit-mt-1 uikit-text-12 uikit-text-w-primary",
          innerHTML: a
        }, null, 8, U))), 128)) : w("", !0)
      ], !0),
      e.$slots["under-label"] ? (s(), d("div", x, [
        v(e.$slots, "under-label", {}, void 0, !0)
      ])) : w("", !0)
    ], 2));
  }
}), ne = /* @__PURE__ */ R(_, [["__scopeId", "data-v-3ecaf466"]]);
export {
  ne as default
};
